import useSWR from 'swr'

import {getIsPartnerUser, getIsCompanyOwner, useUser} from '~/shell/user'

import type {UnpaidInvoicesResponse} from './billing'
import {getDeimos} from './helpers'

export function useUnpaidInvoices() {
    const user = useUser()
    return useSWR<UnpaidInvoicesResponse>(
        user?.companyId && getIsCompanyOwner(user) && !getIsPartnerUser(user)
            ? `/rest/v1/billing/companies/${user?.companyId}/unpaid-invoices/`
            : null,
        getDeimos,
    )
}
